@if (loading$ | async) {
  <hlm-progress />
}

@if (hasSearched$ | async) {
  @if (totalHits$ | async; as total) {
    <div
      [class]="
        'flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ' +
        (total >= 1000
          ? 'border-accent/50 bg-accent/10 text-foreground'
          : 'border-primary/25 bg-primary/5 text-foreground')
      "
    >
      <hlm-icon
        [name]="total >= 1000 ? 'lucideTriangleAlert' : 'lucideInfo'"
        size="1rem"
        [class]="total >= 1000 ? 'text-accent-foreground' : 'text-primary'"
      />
      @if (total >= 1000) {
        Found <strong>{{ total | number }}</strong> results — showing max <strong>1,000</strong>. Refine with filters above.
      } @else {
        Found <strong>{{ total | number }}</strong> results
      }
    </div>
  }
}

@if (results$ | async; as results) {
  @if (results.length > 0) {
    <ag-grid-angular
      class="ag-theme-material cmt-grid"
      [rowData]="results"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [pagination]="true"
      [paginationAutoPageSize]="true"
      [suppressHorizontalScroll]="true"
      [alwaysShowVerticalScroll]="false"
      [getRowClass]="getRowClass"
      (firstDataRendered)="onFirstDataRendered($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      (rowClicked)="onRowClicked($event)"
    />
  } @else {
    <div class="rounded-2xl border border-dashed border-border bg-card/50 p-12 text-center text-sm text-muted-foreground">
      No results found. Please try a different search term.
    </div>
  }
}
